import React, { useEffect, useState } from "react";

import Container from "../../components/ui/Container";
import http from "../../services/httpServices";
import CourseFollowUpSection from "../../components/ui/CourseFollowUpSection";
import ProgressCircle from "../../components/ui/ProgressCircle";
import CenterIcon from "../../components/ui/CenterIcon";
import Form from "../../components/form/elements/Form";
import InputField from "../../components/form/elements/InputField";
import { handleFormErrors, handleInputChange } from "../../services/formServices";
import Button from "../../components/ui/Button";

import { ReactComponent as SideNavCollabseIcon } from "../../assets/parent-dashboard-assets/Arrows.svg";

import decoreHeroContent from "../../assets/parent-dashboard-assets/decoreHeroContent.png";
import parentDashboardImg from "../../assets/parent-dashboard-assets/parentDashboardImg.png";
import { useLanguage } from "../../context/LanguageContext";
const ParentDashboard = () => {
    const [followUpData, setFollowUpData] = useState({ courses: [] });
    const { language } = useLanguage();
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [data, setData] = useState({ phone: "", father_phone: "" });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const getParentDashboardData = async (e) => {
        setIsLoading(true);
        e.preventDefault();
        try {
            await http.get("/sanctum/csrf-cookie");
            const result = await http.post("api/parent_dashboard", {
                phone: parseInt(data["phone"]),
                father_phone: parseInt(data["father_phone"]),
            });
            setFollowUpData(result.data);
            setSelectedCourse([]);
        } catch (error) {
            handleFormErrors(error, setIsLoading, setErrors);
        }
    };

    const handleCourseSelection = (course) => {
        setSelectedCourse(course);
    };
    const content = {
        ar: {
            studentPhone: "رقم هاتف نجلك",
            parentPhone: "رقم هاتفك",
            followButton: "ابدأ المتابعة",
        },
        en: {
            studentPhone: "Your Child's Phone Number",
            parentPhone: "Your Phone Number",
            followButton: "Start Tracking",
        },
        de: {
            studentPhone: "Telefonnummer Ihres Kindes",
            parentPhone: "Ihre Telefonnummer",
            followButton: "Verfolgung starten",
        },
    };
    return (
        <Container className="">
            <div className="flex flex-col items-center justify-center h-fit gap-10">
                <HeroSection />
            </div>
            {!followUpData.full_name ? (
                <Form className=" w-full md:w-1/2 mx-auto  gap-5">
                    <div className="space-y-5 p-8 rounded-md shadow-xl">
                        <InputField
                            placeholder={content[language].studentPhone}
                            id="phone"
                            onChange={handleInputChange}
                            data={data}
                            errors={errors}
                            setData={setData}
                        />
                        <InputField
                            placeholder={content[language].parentPhone}
                            id="father_phone"
                            onChange={handleInputChange}
                            data={data}
                            errors={errors}
                            setData={setData}
                        />
                        <Button
                            color="germanRed"
                            className="w-full"
                            onClick={getParentDashboardData}
                            isLoading={isLoading}
                        >
                            {content[language].followButton}
                        </Button>
                    </div>
                </Form>
            ) : (
                ""
            )}
            <div className="flex gap-5 flex-col md:flex-row">
                <div className="w-full md:w-fit">
                    {followUpData.full_name ? (
                        <StatisticsSection
                            followUpData={followUpData}
                            onCourseSelect={handleCourseSelection}
                        />
                    ) : (
                        ""
                    )}
                </div>
                <div className="w-full">
                    {selectedCourse && followUpData.full_name ? (
                        <CourseFollowUpSection
                            course={selectedCourse}
                            followUpData={followUpData}
                        />
                    ) : (
                        ""
                    )}
                </div>
            </div>
        </Container>
    );
};

const HeroSection = () => {
    const [activeWordIndex, setActiveWordIndex] = useState(0);
    const [loopCount, setLoopCount] = useState(0);
    const { language } = useLanguage();
    const content = {
        ar: {
            title: "لوحة تحكم",
            subtitle: "ولي الأمر",
            description: `دلوقتي تقدر تتابع نجلك أسبوعياً بكل سهولة لكل نشاطاته التعليمية من حيث
                مشاهداته ودرجاته، عشان تكون مطمئن على مستقبله وتبقى جزء من رحلته التعليمية،
                وتساعدنا في تحقيق هدفه للوصول لأفضل النتائج.`,
        },
        en: {
            title: "Parent",
            subtitle: "Dashboard",
            description: `Now you can track your child's weekly activities easily, including views 
                and grades, so you can be assured of their future, be part of their learning journey, 
                and help us achieve their goal of reaching the best results.`,
        },
        de: {
            title: "Eltern",
            subtitle: "Dashboard",
            description: `Jetzt können Sie die wöchentlichen Aktivitäten Ihres Kindes einfach verfolgen, 
                einschließlich Ansichten und Noten, sodass Sie sich um seine Zukunft keine Sorgen machen müssen, 
                Teil seiner Lernreise sein und uns helfen können, sein Ziel zu erreichen.`,
        },
    };

    useEffect(() => {
        const totalLoops = 10;
        const totalWords = 3;

        if (loopCount < totalLoops) {
            const interval = setInterval(() => {
                setActiveWordIndex((prevIndex) => {
                    const newIndex = (prevIndex + 1) % totalWords;
                    if (newIndex === totalWords - 1) {
                        setLoopCount((prevLoop) => {
                            const newLoopCount = prevLoop + 1;
                            return newLoopCount;
                        });
                    }
                    return newIndex;
                });
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [activeWordIndex, loopCount]);
    return (
        <div className="py-10 relative w-screen min-h-[50vh] overflow-hidden  smooth rounded-xl ">
            <div
                className={`container  z-10 mx-auto flex-center-both flex-col-reverse md:flex-row clr-text-primary smooth text-center ${
                    language !== "ar" ? "md:text-left" : "md:text-right"
                } px-4 md:px-20`}
            >
                <div className="smooth rounded-md overflow-hidden py-10 sm:px-5 md:px-20 relative basis-full h-full flex flex-col ">
                    <h1 className="text-3xl py-4 rounded-full smooth clr-text-primary z-10 md:text-5xl font-bold mb-4">
                        {content[language].title}{" "}
                        <span className="font-balabeloo text-primSky-500">
                            {content[language].subtitle}
                        </span>
                    </h1>
                    <img
                        src={decoreHeroContent}
                        alt="Lamp"
                        className="w-[150px] absolute  -bottom-5 right-0 opacity-30"
                    />
                    <p className="mt-6 text-lg font-expo md:text-xl dark:text-gray-300 smooth text-gray-600 max-w-xl">
                        {content[language].description}
                    </p>
                </div>
                <div className="md:basis-1/2 basis-full h-full flex-center-both">
                    <div className="w-full h-full flex-center-both max-w-md">
                        <img
                            src={parentDashboardImg}
                            alt={"decoreHeroContent-parent-png"}
                            className="dark:opacity-90 smooth w-full"
                        />
                    </div>
                </div>

                {/* <div className="flex justify-center items-center gap-6">
                    <span role="img">
                    <img src={PhyDecore} alt="PhyDecore" className="w-10 opacity-40" />
                    </span>
                    <h2 className="text-2xl font-lama md:text-5xl fade-in-out lg:text-8xl font-bold text-cyan-600/40 dark:text-cyan-400/50 smooth">
                        <span
                            className={`${
                                activeWordIndex === 0 ? "text-stroke" : "text-stroke-none"
                            } `}
                        >
                            رافق.
                        </span>{" "}
                        <span
                            className={`${
                                activeWordIndex === 1 ? "text-stroke" : "text-stroke-none"
                            } `}
                        >
                            نجاحه.
                        </span>{" "}
                        <span
                            className={`${
                                activeWordIndex === 2 ? "text-stroke" : "text-stroke-none"
                            } `}
                        >
                            الدائم
                        </span>
                    </h2>
                    <span role="img">
                        <img src={PhyDecore} alt="PhyDecore" className="w-10 opacity-40" />
                    </span>
                </div> */}
            </div>
        </div>
    );
};

const StatisticsSection = ({ followUpData, onCourseSelect = () => null }) => {
    // console.log("followUpData", JSON.stringify(followUpData));
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <section className={`space-y-10 h-full `}>
            {followUpData.courses.length > 0 ? (
                <>
                    <nav
                        className={`flex flex-row md:flex-col h-full bg-[#F8F8F8] flex-wrap md:flex-nowrap space-x-6 md:space-x-0 dark:bg-slate-900 border border-black rounded-xl p-5 space-y-4 smooth ${
                            isCollapsed ? "w-full md:w-16" : "w-full h-full "
                        }`}
                    >
                        <div className="flex justify-center w-full mb-4">
                            <button
                                onClick={toggleCollapse}
                                className="p-2 rounded-full border-[1px] group"
                            >
                                <SideNavCollabseIcon
                                    className={`w-10 h-auto fill-primSky-500 group-hover:fill-secYellow-500  ${
                                        isCollapsed
                                            ? "rotate-90 md:rotate-0"
                                            : "-rotate-90 md:rotate-180"
                                    } smooth`}
                                />
                            </button>
                        </div>
                        {followUpData.courses.map((course, index) => (
                            <Button
                                key={index}
                                onClick={() => onCourseSelect(course)}
                                state={{ course }}
                                className={`block p-3 text-lg flex-center-both flex-col text-center clr-text-primary font-semibold border-none bg-cyan-200 dark:bg-cyan-700 smooth hover:bg-cyan-300 rounded-lg transition-colors duration-300 ease-in-out ${
                                    isCollapsed ? "text-center" : "text-left"
                                }`}
                            >
                                <span className=""> - {index} - </span>
                                {!isCollapsed && course.name}
                            </Button>
                        ))}
                    </nav>
                </>
            ) : (
                ""
            )}
        </section>
    );
};

const OverviewStatistics = () => {
    return (
        <div>
            <div className="font-w-bold text-center font-h1 pt-5 pb-10 flex-center-both space-x-3 space-x-reverse">
                <CenterIcon icon="arcticons:questionnaire-star" className="text-cyan-500" />
                <span>
                    احصائيات إجمالية لنجلك في{" "}
                    <span className="text-cyan-500">الكورسات اللي هو مشترك فيها</span>{" "}
                </span>
                <CenterIcon icon="arcticons:questionnaire-star" className="text-cyan-500" />
            </div>
            <div className="w-full flex items-center justify-evenly">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 items-start">
                    <ProgressCircle
                        color="blue"
                        unit="فيديو"
                        title="عدد الفيديوهات نجلك شافها"
                        value={5}
                        max={10}
                        textsIndex={3}
                    />
                    <ProgressCircle
                        color="cyan"
                        unit="امتحان و واجب"
                        title="عدد الامتحانات و الواجبات نجلك خلصها"
                        value={5}
                        max={10}
                        textsIndex={2}
                    />
                    <ProgressCircle
                        color="purple"
                        unit={false}
                        title="متوسط نتائج نجلك"
                        value={5}
                        max={10}
                        textsIndex={1}
                    />
                </div>
            </div>
        </div>
    );
};

export default ParentDashboard;
